// Hover-revealed "show the calls behind this" button. `scope` is a
// filter diff merged over the dashboard filters; `tier` picks the
// drawer tab; `as` = 'pill' | 'icon' | 'menu-item'.

import React, { useContext } from 'react'
import { IconPhone } from '@tabler/icons-react'

import { Pill } from '@/components/pills/Pill'
import { Button } from '@/components/buttons/Button'

import { BrowseCallsContext } from '../helpers/dashboardContexts'

export const ShowCallsButton = ({
  scope,
  tier,
  label = 'Show calls',
  as = 'pill',
  title,
  onClick,
}) => {
  const { openBrowseCalls } = useContext(BrowseCallsContext)
  const handleClick = (event) => {
    // Most consumers paint this inside a row/bar that already has
    // its own click handler (drilldown into a drawer). Stop event
    // propagation so the "show calls" click doesn't also fire the
    // drawer open.
    if (event?.stopPropagation) {
      event.stopPropagation()
    }
    openBrowseCalls({ ...(scope || {}), ...(tier ? { initialTier: tier } : {}) })
    if (onClick) {
      onClick(event)
    }
  }

  // The pill variant renders as a Pill (a <div>), so restore the
  // button-key affordance a native <button> gave it for free.
  const handleKeyActivate = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      handleClick(event)
    }
  }

  if (as === 'icon') {
    return (
      <Button
        basic
        square
        small
        onClick={handleClick}
        tooltip={title || label}
        aria-label={title || label}
      >
        <IconPhone />
      </Button>
    )
  }
  if (as === 'menu-item') {
    return (
      <button type="button" className="show-calls-menu-item" onClick={handleClick} title={title}>
        <IconPhone size={14} />
        <span>{label}</span>
      </button>
    )
  }

  return (
    <Pill
      brand
      small
      clickable
      icon={<IconPhone />}
      content={label}
      role="button"
      tabIndex={0}
      title={title}
      onClick={handleClick}
      onKeyDown={handleKeyActivate}
    />
  )
}
